module.exports = __webpack_public_path__ + "static/payouts-background-308cd4547925e629b83ba322fd65b041.webp";